import appConstants from "../../../../../appConstants";
import { NumericEditor } from "../../../../dataGrid/cellEditors";

export default class GridConfig {
    constructor(configuration){
        const config = configuration || {};
        this.name = "GridConfiguration";
        this.config = GridConfig.getConfiguration(config);
    }
    static getConfiguration(config) {
      return GridConfig.getDefaultConfiguration();
    }

    static getDefaultConfiguration() {
    return {
      title: appConstants.gridNames.KPIGoals,
      keyColumn: "kpiName",
      enableFilters: false,
      enableSorting: false,
      columns: [
        {
          headerName: "KPI",
          field: "displayName",
          minWidth: appConstants.columnWidth.KPI_NAME,
        },
        {
          headerName: "Goal",
          field: "kpiValue",
          editable: true,
          minWidth: appConstants.columnWidth.KPI_VALUE,
          cellEditorFramework: NumericEditor
        }
      ]
    }
  }
}

